import axios from "axios";

export const AuthLogoutApi = async (token) => {
  try {
    const AUTH_BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/auth/logout?";
    const endpoint = `${AUTH_BASED_URL}${path}token=${token}`;

    const response = await axios.post(endpoint);
    return response;
  } catch (error) {
    console.log("ini error auth login");
    console.log(error);
    return error.response;
  }
};

export default AuthLogoutApi;
